"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PhoneSolid: function() {
        return PhoneSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PhoneSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 4C1 2.34315 2.34315 1 4 1H6.1802C7.13356 1 7.95439 1.67292 8.14136 2.60777L8.87562 6.27909C9.00677 6.93481 8.80152 7.61269 8.32867 8.08554L6.79391 9.6203C6.53572 9.87849 6.46978 10.2019 6.55121 10.4488C7.63989 13.7491 10.2509 16.3601 13.5512 17.4488C13.7981 17.5302 14.1215 17.4643 14.3797 17.2061L15.9145 15.6713C16.3873 15.1985 17.0652 14.9932 17.7209 15.1244L21.3922 15.8586C22.3271 16.0456 23 16.8664 23 17.8198V20C23 21.6569 21.6569 23 20 23H17C8.16344 23 1 15.8366 1 7V4Z",
        fill: "currentColor"
    })
}), "PhoneSolid");
const _default = PhoneSolid;
